<template>
  <v-form
    v-model="valid"
    lazy-validation
    ref="userResetPasswordForm"
    class="d-flex flex-column pa-4"
  >
    <div class="d-flex justify-space-between align-center">
      <h5 class="mb-2">Reset Password - {{ firstName }} {{ lastName }}</h5>
      <v-btn icon small
        ><v-icon small @click="$emit('close')">mdi-close</v-icon></v-btn
      >
    </div>
    <v-textField
      v-model="password"
      type="password"
      dense
      :rules="[rules.required]"
    >
      <template #label>
        <span class="text-caption">Password</span>
      </template>
    </v-textField>

    <v-textField
      v-model="confirmPassword"
      type="password"
      dense
      :rules="[rules.required, matchPassword]"
    >
      <template #label>
        <span class="text-caption">Confirm Password</span>
      </template>
    </v-textField>
    <div class="align-self-end">
      <v-btn
        small
        color="secondary"
        class="text-capitalize"
        text
        @click="$refs.userResetPasswordForm.reset()"
        >clear</v-btn
      >
      <v-btn
        small
        rounded
        class="text-capitalize"
        color="primary"
        @click="handleSubmit"
      >
        Reset Password
      </v-btn>
    </div>
  </v-form>
</template>

<script>
import { rules } from "../../utils/validation";
import { resetUserPassword } from "@/services/user";
import { mapActions } from "vuex";

export default {
  name: "UserPasswordResetFormNew",
  props: {
    userId: {
      type: String,
      required: true,
    },
    firstName: {
      type: String,
      required: true,
    },
    lastName: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      rules,
      valid: false,
      password: "",
      confirmPassword: "",
    };
  },
  methods: {
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage",
    ]),
    matchPassword() {
      return (
        (this.password &&
          this.confirmPassword &&
          this.password === this.confirmPassword) ||
        "Password don't match"
      );
    },
    async handleSubmit() {
      const form = this.$refs.userResetPasswordForm;
      console.log(form.validate());
      if (!form.validate()) return;

      try {
        const token = localStorage.getItem("token");
        const data = {
          password: this.password,
          confirmPassword: this.confirmPassword,
          token,
        };
        const res = await resetUserPassword(data);
        if (res.status === 200) {
          this.addSuccessMessage("Password has been successfully reset.");
          this.$emit("close");
        }
      } catch (err) {
        this.addErrorMessage("Password reset failed. Please try again.");
      }
    },
  },
};
</script>
